import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { AddUserRequestDto } from './dto/request/add-user.request.dto';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { UpdateUserRequestDto } from './dto/request/update-user.request.dto';
import { UpdateUserResponseDto } from './dto/response/update-user.response.dto';
import { UserDetailsResponseDto } from './dto/response/user-details.response.dto';
import { GetUserByIdResponseDto } from './dto/response/get-user-by-id.response.dto';
import { cognitoUserDetails } from '../../store/UserManagement/userManagementTypes';
import { AddManyUsersResponseDto } from './dto/response/add-many-users.response.dto';

const USERS_PATH = HttpPathsEnum.USERS;

class UserManagementApi {
  public async removeUser(id: number) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/company-owner/${id}`,
      method: RequestType.DELETE,
    };

    return await AppHttpClient.exec<any, boolean>(request, Boolean);
  }

  public async addUser(data: AddUserRequestDto) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/company-owner/add-new-user`,
      method: RequestType.POST,
      data,
    };

    return await AppHttpClient.exec<AddUserRequestDto, UserDetailsResponseDto>(
      request,
      UserDetailsResponseDto
    );
  }

  public async updateUser(id: number, data: UpdateUserRequestDto) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/company-owner/update/${id}`,
      method: RequestType.PATCH,
      data,
    };

    return await AppHttpClient.exec<
      UpdateUserRequestDto,
      UpdateUserResponseDto
    >(request, UpdateUserResponseDto);
  }

  public async addManyUsersFromFile(data: any) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/company-owner/add-many-users`,
      method: RequestType.POST,
      data,
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    return await AppHttpClient.exec<any, boolean>(request, Boolean);
  }

  public async getUserById(id: number) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/company-owner/get-user-by-id/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetUserByIdResponseDto>(
      request,
      GetUserByIdResponseDto
    );
  }

  public async resendUserEmail(data: cognitoUserDetails) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/company-owner/resend-email-notification`,
      method: RequestType.POST,
      data,
    };

    return await AppHttpClient.exec<cognitoUserDetails, UserDetailsResponseDto>(
      request,
      UserDetailsResponseDto
    );
  }
}

export default new UserManagementApi();
